import { memo, useMemo } from 'react';
import { isEmpty } from 'lodash';
import { Chip } from '@mui/material';
import { useFirestore } from '@client/hooks/utils.hooks';
import { totalProductCapacity, totalProductPurchased } from '@sda/utils/meta';

interface SoldOutIndicatorProps {
  readonly showId: string;
}

export const SoldOutIndicator = memo<SoldOutIndicatorProps>(({ showId }) => {
  const [products, isLoading] = useFirestore((SDK) => SDK.Products.listBy((query) => [
    query.isEqualTo('showId', showId),
    query.isTrue('isActive'),
  ]), {
    key: showId,
  });

  const isSoldOut = useMemo(() => {
    const totalNumTicketsPurchased = totalProductPurchased(products);
    const totalCapacity = totalProductCapacity(products);

    return totalNumTicketsPurchased >= totalCapacity;
  }, [products]);

  if (isEmpty(products) || isLoading) {
    return null;
  }

  if (!isSoldOut) {
    return null;
  }

  return (
    <Chip
      size="small"
      color="error"
      label="Sold Out"
    />
  );
});
